import React from 'react';
import { Routes, Route } from 'react-router';
import withWaitingComponent from 'Common/HOC/withWaitingComponent';

const ImprintScreen = React.lazy(
  () =>
    import(
      /* webpackChunkName: "legalImprintModule" */
      './screens/Imprint'
    )
);

const LegalRouter = () => (
  <Routes>
    <Route path="" element={withWaitingComponent(ImprintScreen)} />
  </Routes>
);
export default LegalRouter;
